import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import HeroCarousel from "./components/HeroCarousel";
import QuickCategories from "./components/QuickCategories";
import NewsList from "./components/NewsList";
import HotPicks from "./components/HotPicks";

const stats = [
  { value: "1200+", label: "影视条目" },
  { value: "8600+", label: "剧情解析" },
  { value: "150万", label: "影迷用户" },
  { value: "24h", label: "资讯更新" },
];

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title="唐心 - 最新影视资讯与热门电视剧电影推荐"
        description="唐心网站汇聚最新影视资讯、热门电视剧与电影内容，提供丰富的视频介绍与剧情分析，助您轻松了解影视动态和精彩作品。"
        keywords="唐心,影视资讯,电视剧推荐,电影推荐,剧情介绍,影视动态,热门影视"
        canonicalPath="/"
      />

      <HeroCarousel />
      <QuickCategories />
      <NewsList />
      <HotPicks />

      <section className="w-full px-4 md:px-6 mt-16">
        <div className="overflow-hidden rounded-xl bg-primary-900 text-background-100">
          <div className="grid grid-cols-1 gap-8 px-6 py-10 md:px-12 md:py-14 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="font-label text-xs tracking-[0.3em] text-accent-400">
                ABOUT TANGXIN
              </span>
              <h2 className="mt-3 text-2xl font-bold text-background-50 font-heading md:text-3xl">
                关于唐心影视
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-primary-200 md:text-base">
                唐心专注于为影视爱好者提供优质的资讯与推荐服务。我们每日追踪影视行业动态，整理热播剧集与院线新片，用严谨的评分与细致的剧情分析，帮助你在海量内容中快速找到真正值得一看的作品。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  了解唐心
                </Link>
                <Link
                  to="/category/电视剧"
                  className="whitespace-nowrap rounded-md bg-primary-800 px-5 py-2.5 text-sm font-medium text-background-100 hover:bg-primary-700 transition-colors cursor-pointer"
                >
                  进入剧集库
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg bg-primary-800 p-4 md:p-5"
                >
                  <p className="font-label text-2xl font-semibold text-accent-400 md:text-3xl">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-primary-200 md:text-sm">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}